import React from 'react';

import { SubHeading } from '../../Components';
import { images } from '../../constants';
import './Chef.css';

const Chef = () => (
  <div className="app__bg app__wrapper section__padding">
  <div className="app__wrapper_img app__wrapper_img-reverse" data-aos="fade-left">
    <img className="app__wrapper_img_border" src={images.chef} alt="chef_image" />
  </div>
  <div className="app__wrapper_info" data-aos="fade-right">
    <SubHeading title="Chef's Philosophy" />
    <h1 className="headtext__cormorant">Our Culinary Vision</h1>

    <div className="app__chef-content" data-aos="fade-up">
      <div className="app__chef-content_quote">
        <img src={images.quote} alt="quote_image" />
        <p className="p__opensans">"Excellence in every dish, passion in every bite."</p>
      </div>
      <p className="p__opensans">
        At Giovani, we believe in crafting unforgettable culinary experiences. Our dishes are a celebration of flavors, combining tradition with innovation. Every plate reflects our dedication to quality, creativity, and a deep respect for ingredients.
      </p>
    </div>

    <div className="app__chef-sign" data-aos="fade-up">
      <p>Fellip Giovani</p>
      <p className="p__opensans">Chef & Founder</p>
    </div>
  </div>
</div>
);
export default Chef;